import {atom} from 'recoil';

export const authUserState = atom({
  key: 'authUserState',
  default: null,
  dangerouslyAllowMutability: true,
});
